import React from 'react';
import { createOid } from '@/utils/eventtracing';
import InfoDetail from './components/InfoDetail';
import Result from './components/ResultList/Result';

export default () => {
  return (
    <div
      data-log={JSON.stringify({
        oid: createOid(),
        isPage: true,
        params: {
          initUrl: window.location.origin+window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
      style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <InfoDetail />
      <Result />
    </div>
  );
};
